import { Alert, Flex, Typography } from "antd"

import Icon from "../../../../Icon"
import { modalConfig } from "../../../../theme"

import "./styles.less"

const { Text } = Typography

export const showDisconnectPaymentModal = ({ modal, isMobile, t, payment, namePayment, onOk }) => {
  modal.confirm({
    ...modalConfig("exclamation"),
    centered: !isMobile,
    icon: null,
    className: "disconnect-payment-modal",

    content: (
      <Flex vertical gap={16}>
        <Icon type="circle_question" style={{ fontSize: 64 }} />
        <Flex vertical gap={8}>
          <Text strong style={{ fontSize: 16 }}>
            {t("Disconnect _namePayment_?", { namePayment })}
          </Text>
          <Text type="secondary">
            {payment.service_name === "stripe"
              ? t(
                  "Disconnecting Stripe stops automatic refunds, cancels subscriptions and turns off Credit automation if it’s enabled."
                )
              : t(
                  "Disconnecting _namePayment_ stops automatic refunds and turns off Credit automation if it’s enabled. Your alerts and billing will continue.",
                  { namePayment }
                )}
          </Text>
          <Alert
            type="error"
            showIcon
            icon={<Icon type="alert_triangle_error" />}
            message={t(
              "If no new integration is connected within 12 hours, the system will unenroll your account. If you don’t want this to happen, please reach out to Support."
            )}
          />
        </Flex>
      </Flex>
    ),

    cancelText: t("Cancel"),
    okText: t("Disconnect"),
    okButtonProps: {
      ...modalConfig("exclamation")?.okButtonProps,
      danger: true,
      ghost: true
    },
    onOk
  })
}
